export const GENERIC_INPUTS = [
  'aoi_id',
  'project_id',
  'asset_id',
  'date',
  'num_class',
  'upsample_factor',
  'num_segments',
  'number_of_components',
  'magnification',
  'k',
  'sun_elevation_angle',
  'satellite_look_angle',
  'wavlist',
  'sensitivity'
];

// TODO: CD related inputs are included for the sake of v1 integration in
// workflows, until Dexter introduces Indice Block
export const EXCLUDE_INPUTS = [];

export const CHANGE_DETECTION_INPUT_RESTRICTION = [
  'class_map',
  'isindexmap',
  'indexclasses',
  'pixxel_LULC_classified',
  'vector_clip',
  'class_colors',
  'class_intervels'
];

export const SAM_MODELS = ['normal', 'high'];

export const JOB_STATUS = {
  failed: ['cancelledOrTerminated', 'failed', 'unknown'],
  inProgress: ['created', 'inprogress'],
  completed: ['completed']
};

export const TASK_STATUS = {
  inProgress: ['created', 'inprogress'],
  completed: ['completed'],
  failed: ['failed', 'error', 'unknown'],
  skipped: ['skipped', 'omitted']
};

/**
 * @enum {String} - Validation error strings from dexter
 */
export const VAL_ERRORS = {
  missingInputs: 'missing_inputs',
  duplicateComponentName: 'duplicate_component_name',
  componentNotFound: 'component_not_found',
  cyclicGraph: 'cycle_in_workflow',
  invalidComponentInput: 'invalid_component_input',
  invalidComponentOutput: 'invalid_component_output',
  invalidConnection: 'invalid_component_connection'
};

export const REACTFLOW_ID_PREFIX_EDGE = 'reactflow__edge';
export const DEXTER_TOKEN_KEY = 'estimated_cost';
/**
 * @enum {String} - for all input formats
 */
export const INPUT_FORMATS = {
  FormatRaster: 'raster',
  FormatVector: 'vector',
  FormatString: 'string',
  FormatNumber: 'number',
  FormatDate: 'date',
  FormatTypeTabular: 'tabular'
};

export const VISUALISATION_TYPES = {
  discrete: 'discrete',
  continuous: 'continuous',
  bucket: 'bucket'
};
